import { Menu, MenuItem } from "@mui/material"
import { observer } from "mobx-react-lite"
import ContextMenuStore from "./store"

type Props = {
  store: ContextMenuStore<any>
}

const ContextMenu = observer(({ store }: Props) => {
  
  return (
    <Menu 
      open={store.opened} 
      anchorReference="anchorPosition"
      anchorPosition={store.menuAnchorPos} 
      onClose={store.close}
      transitionDuration={200}
      sx={{ 
        ".MuiMenuItem-root": {
          height: 36,
          fontWeight: 600,
          paddingRight: 4.5,
          "&>.MuiSvgIcon-root": {
            marginRight: 1.5
          },
          ".sub": {
            position: 'absolute',
            right: 16,
            color: 'primary.main'
          }
        }
      }}
    >
      { store.menuItems.map((item, index) => (
        <MenuItem 
          disabled={!item.onClick}
          key={index} 
          sx={item.sx} 
          onClick={() => store.handleClick(item)}
        >
          { item.icon }
          { item.title }
          { item.sub && <div className="sub">{ item.sub }</div> }
        </MenuItem>
      ))}
    </Menu>
  )
})

export default ContextMenu